import http from '../../services/http';
import { STATES, STATE_KEYS, getBestMatchingString } from '../utils';
import Hubspot from '../../services/Hubspot';

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('LLCCostsByState', (csrfToken, formAction) => ({
        search: '',
        cityFound: null,
        citySuggestion: null,
        loading: false,
        showModal: false,
        modalForm: {
          email: '',
          iWantTo: '',
          agreed: false,
        },
        errors: {},
        successMessage: null,
        errorMessage: null,
        onChangeSearch: debounce(function (newValue) {
          this.search = newValue;
          this.loading = true;
          this.cityFound = null;
          this.citySuggestion = null;

          if (!newValue) {
            this.loading = false;
            return;
          }

          const rightWrittenCitysFound = STATES.filter(
            (state) =>
              state.toLowerCase().includes(newValue.toLowerCase()) ||
              newValue.toLowerCase().includes(state.toLowerCase()),
          );

          const suggestion =
            rightWrittenCitysFound?.length > 0
              ? rightWrittenCitysFound[0]
              : getBestMatchingString(newValue, STATES);

          if (suggestion.toLowerCase() === newValue.toLowerCase()) {
            this.getCityInfo(newValue);
          } else {
            this.citySuggestion = suggestion;
            this.loading = false;
          }
        }, 300),
        async getCityInfo(city) {
          this.search = city;
          const apiUrl =
            import.meta.env.VITE_GET_PRICE_BY_STATE_URL ||
            'https://api.incfile.com/api/v1/get-price-by-state/';
          const response = await http.get(
            `${apiUrl}?state=${STATE_KEYS[city]}`,
            { headers: null },
          );
          if (response.status === 200) {
            this.cityFound = response.data;
            this.loading = false;
          } else {
            this.cityFound = null;
            this.loading = false;
          }
        },
        useCitySuggestion() {
          this.loading = true;
          this.getCityInfo(this.citySuggestion);
          this.citySuggestion = null;
        },
        validateEmail(email) {
          const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return re.test(email.toLowerCase());
        },
        validateField(fieldName) {
          delete this.errors[fieldName];
          switch (fieldName) {
            case 'email':
              if (!this.modalForm.email.trim()) {
                this.errors.email = 'Please complete this required field.';
              } else if (!this.validateEmail(this.modalForm.email)) {
                this.errors.email = 'Email must be formatted correctly.';
              }
              break;

            case 'iWantTo':
              if (!this.modalForm.iWantTo.trim()) {
                this.errors.iWantTo = 'Please complete this required field.';
              }
              break;

            case 'agreed':
              if (!this.modalForm.agreed) {
                this.errors.agreed = 'Please complete this required field.';
              }
              break;

            default:
              break;
          }
        },
        validateAll() {
          this.errors = {};

          Object.keys(this.modalForm).forEach((fieldName) => {
            this.validateField(fieldName);
          });
        },
        resetForm() {
          this.modalForm.email = '';
          this.modalForm.iWantTo = '';
          this.modalForm.agreed = false;
        },
        async submitForm() {
          this.validateAll();

          if (Object.keys(this.errors).length > 0) {
            return;
          }

          const payload = {
            email: this.modalForm.email,
            intent_path: this.modalForm.iWantTo,
          };

          try {
            const { data } = await Hubspot.submitDownloadGuideLLC(payload);
            if (data.success) {
              this.showMessage = true;
              this.successMessage = data.data.inlineMessage;
              this.errorMessage = null;
              this.resetForm();
            } else {
              console.error('Failed to submit form');
              this.showMessage = true;
              this.successMessage = null;
              this.errorMessage = 'Failed to submit form, try again.';
            }
          } catch (error) {
            console.error('Error:', error);
            this.showMessage = true;
            this.successMessage = null;
            this.errorMessage = 'Failed to submit form, try again.';
          }
        },
      }));
    });
  },
};

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
